/*
 *
 * @desc: 移动端导航相关配置
 * @author: haifn
 * @time: 2021/7/16 4:56 下午
 *
 */
import { isBroswer, handleInstaLink } from '@/utils';

/*
 *
 * @desc: 获取已登录用户个人中心菜单
 *        1. 添加回调事件
 *        2. 判断用户是否为分销商提供分销商入口
 * @param {State} auth 状态
 *                reseller 分销商状态
 * @return {Array} MenuPersonal
 * @time: 2021/7/19 5:19 下午
 *
 *
 */
export function getPersonalMenusList(props) {
  const {
    auth,
    reseller,
    area: { LANG },
  } = props;
  const menus = [];
  if (isBroswer) {
    /*
     * @desc: 已登录用户个人中心菜单
     * @params Object   数组对象
     *         @name    内部名称/GA埋点event label
     *         @title   对外展示多语言标题
     *         @url     内部路由地址/外部超链接地址
     *         @type    link 内部路由地址 || hyperlink 外部超链地址 || button 执行回调函数
     *         @onClick type === 'button' 相应的回调函数
     *         @disabledIcon 是否禁用icon
     *
     */
    const MenuPersonal = [
      {
        name: '登录',
        title: LANG['common.btn.login'],
        url: handleInstaLink('www', `/account/login`),
        type: 'hyperlink',
        icon: 'https://res.insta360.com/static/3909400a6d439e88d21657fe0eb84fe6/account.svg',
        disabledIcon: true,
      },
      {
        name: '注册',
        title: LANG['common.btn.register'],
        url: handleInstaLink('www', `/account/register`),
        type: 'hyperlink',
        icon: 'https://res.insta360.com/static/3909400a6d439e88d21657fe0eb84fe6/account.svg',
        disabledIcon: true,
      },
      {
        name: '我的订单',
        title: LANG['common.label.orders'],
        url: '/order/list',
        type: 'link',
        icon: 'https://res.insta360.com/static/20312c76dda49ca2ed6f7c8ba2d10743/order.svg',
      },
      {
        name: '推广联盟',
        title: LANG['common.label.affiliateProgram'],
        url: '/center',
        type: 'link',
        icon: 'https://res.insta360.com/static/105614b703ded84b54cad3add91f9865/ic_aff.svg',
      },
      {
        name: '积分商城',
        title: LANG['gold_mall.header_nav_0'],
        url: '/gold',
        type: 'link',
        icon: 'https://res.insta360.com/static/0ef1002abcda87e1a88b3f0e51ac5e47/goldStore.svg',
      },
      {
        name: '我的账户',
        title: LANG['gold_mall.btn_account_profile'],
        url: handleInstaLink('www', `/account/profile`, ''),
        type: 'hyperlink',
        icon: 'https://res.insta360.com/static/3909400a6d439e88d21657fe0eb84fe6/account.svg',
      },
      {
        name: '云存储管理',
        title: LANG['common.label.subscription'],
        url: '/subscription/management',
        type: 'link',
        icon: 'https://res.insta360.com/static/2f1fb41f38eeb0d8008a0e47a2ff2067/subscribe.svg',
      },
      {
        name: '常见问题',
        title: LANG['common.label.faqs'],
        url: '/faq',
        type: 'link',
        icon: 'https://res.insta360.com/static/76d0826ee7d418968c90ff4e9ec94fab/faq.svg',
      },
      {
        name: '退出登录',
        title: LANG['common.btn.logout'],
        type: 'button',
        icon: 'https://res.insta360.com/static/c8082acd364237c3f01ce327342dc111/logout.svg',
        onClick: () => {},
      },
    ];
    MenuPersonal.forEach((o) => {
      switch (o.name) {
        case '登录':
        case '注册':
          if (!auth.isLoggedIn) menus.push(o);
          break;
        case '我的订单':
        case '积分商城':
        case '我的账户':
        case '常见问题':
        case '云存储管理':
          if (auth.isLoggedIn) menus.push(o);
          break;
        case '推广联盟':
          if (auth.isLoggedIn && reseller?.isIndividualReseller) menus.push(o);
          break;
        case '退出登录':
          if (auth.isLoggedIn) {
            o.onClick = auth.logout;
            menus.push(o);
          }
          break;
        default:
          break;
      }
    });
  }
  return menus;
}

// 仅0，1，2为公用主题，其他为活动页使用
export const navStyleConfig = {
  dark: {
    type: 'dark',
    topbarBgColor: '#fff',
    backGroundColor: 'transparent',
    fontColor: '#262629',
    navBottomBorder: 'transparent',
    bannerArrow: 'https://res.insta360.com/static/614d696aa97148280f23f5f0c667a876/%E9%BB%91%E7%AE%AD%E5%A4%B4.png',
    cartIcon: 'https://res.insta360.com/static/0bbd24116476290f06cd790175f42d8f/cart-icon-dark.svg',
    personalIcon: 'https://res.insta360.com/static/08e2b531bb9de45484a7802b496ff38e/personal-icon-dark.svg',
    storeLogo: {
      cn: 'https://res.insta360.com/static/7821b50bc9463f9ed06a0b77e129dda6/nav-logo-dark-cn.svg',
      en: 'https://res.insta360.com/static/f0057eb9016d0563e4f561572e962b6b/nav-logo-dark-en.svg',
      mob_cn: 'https://res.insta360.com/static/7821b50bc9463f9ed06a0b77e129dda6/nav-logo-dark-cn.svg',
      mob_en: 'https://res.insta360.com/static/f0057eb9016d0563e4f561572e962b6b/nav-logo-dark-en.svg',
    },
    colorType: 1,
    actColorType: 1,
    searchIcon: 'https://res.insta360.com/static/e7785c23fcbc4c6374ab1575d5647b08/dark-search-icon.svg',
  },
  light: {
    type: 'light',
    topbarBgColor: '#fff',
    backGroundColor: 'transparent',
    fontColor: '#fff',
    navBottomBorder: 'transparent',
    bannerArrow: 'https://res.insta360.com/static/eb51ef943d670b18ef26e00618372469/%E7%99%BD%E7%AE%AD%E5%A4%B4.png',
    cartIcon: 'https://res.insta360.com/static/7ec2ae41188f502af447d429cdd51da1/cart-icon-light.svg',
    personalIcon: 'https://res.insta360.com/static/303389f4c8bcc5d6abbdd76a308feeab/personal-icon-light.svg',
    storeLogo: {
      cn: 'https://res.insta360.com/static/37c0e4866b8bda5016e245e8101a965f/nav-logo-light-cn.svg',
      en: 'https://res.insta360.com/static/adf29294d348ad1a7d60c96dc577225e/nav-logo-light-en.svg',
      mob_cn: 'https://res.insta360.com/static/37c0e4866b8bda5016e245e8101a965f/nav-logo-light-cn.svg',
      mob_en: 'https://res.insta360.com/static/adf29294d348ad1a7d60c96dc577225e/nav-logo-light-en.svg',
    },
    colorType: 2,
    actColorType: 2,
    searchIcon: 'https://res.insta360.com/static/5d71ed852c86cbfa6bc6ffd704ed0f5b/light-search-icon.svg',
  },
  darkTransparentFull: {
    type: 'darkTransparentFull',
    topbarBgColor: '#fff',
    backGroundColor: 'transparent',
    fontColor: 'transparent',
    navBottomBorder: 'transparent',
    bannerArrow: 'https://res.insta360.com/static/614d696aa97148280f23f5f0c667a876/%E9%BB%91%E7%AE%AD%E5%A4%B4.png',
    cartIcon: 'https://res.insta360.com/static/0bbd24116476290f06cd790175f42d8f/cart-icon-dark.svg',
    personalIcon: 'https://res.insta360.com/static/08e2b531bb9de45484a7802b496ff38e/personal-icon-dark.svg',
    storeLogo: {
      cn: 'https://res.insta360.com/static/7821b50bc9463f9ed06a0b77e129dda6/nav-logo-dark-cn.svg',
      en: 'https://res.insta360.com/static/f0057eb9016d0563e4f561572e962b6b/nav-logo-dark-en.svg',
      mob_cn: 'https://res.insta360.com/static/7821b50bc9463f9ed06a0b77e129dda6/nav-logo-dark-cn.svg',
      mob_en: 'https://res.insta360.com/static/f0057eb9016d0563e4f561572e962b6b/nav-logo-dark-en.svg',
    },
    colorType: 3,
    actColorType: 3,
    searchIcon: 'https://res.insta360.com/static/e7785c23fcbc4c6374ab1575d5647b08/dark-search-icon.svg',
  },
  lightTransparentFull: {
    type: 'lightTransparentFull',
    topbarBgColor: '#fff',
    backGroundColor: 'transparent',
    fontColor: 'transparent',
    navBottomBorder: 'transparent',
    bannerArrow: 'https://res.insta360.com/static/614d696aa97148280f23f5f0c667a876/%E9%BB%91%E7%AE%AD%E5%A4%B4.png',
    cartIcon: 'https://res.insta360.com/static/7ec2ae41188f502af447d429cdd51da1/cart-icon-light.svg',
    personalIcon: 'https://res.insta360.com/static/303389f4c8bcc5d6abbdd76a308feeab/personal-icon-light.svg',
    storeLogo: {
      cn: 'https://res.insta360.com/static/37c0e4866b8bda5016e245e8101a965f/nav-logo-light-cn.svg',
      en: 'https://res.insta360.com/static/adf29294d348ad1a7d60c96dc577225e/nav-logo-light-en.svg',
      mob_cn: 'https://res.insta360.com/static/37c0e4866b8bda5016e245e8101a965f/nav-logo-light-cn.svg',
      mob_en: 'https://res.insta360.com/static/adf29294d348ad1a7d60c96dc577225e/nav-logo-light-en.svg',
    },
    colorType: 4,
    actColorType: 4,
    searchIcon: 'https://res.insta360.com/static/5d71ed852c86cbfa6bc6ffd704ed0f5b/light-search-icon.svg',
  },
  default: {
    type: 'default',
    topbarBgColor: '#f8f9fc',
    backGroundColor: '#FFFFFF',
    fontColor: '#262629',
    navBottomBorder: '#efefef', // 导航栏底边的一个边框线
    bannerArrow: 'https://static.insta360.com/assets/storage/20190615/4261ec7cee8a699cd246cfe257d83cec/ic_right@2x.png',
    cartIcon: 'https://res.insta360.com/static/0bbd24116476290f06cd790175f42d8f/cart-icon-dark.svg',
    personalIcon: 'https://res.insta360.com/static/08e2b531bb9de45484a7802b496ff38e/personal-icon-dark.svg',
    storeLogo: {
      cn: 'https://res.insta360.com/static/7821b50bc9463f9ed06a0b77e129dda6/nav-logo-dark-cn.svg',
      en: 'https://res.insta360.com/static/f0057eb9016d0563e4f561572e962b6b/nav-logo-dark-en.svg',
      mob_cn: 'https://res.insta360.com/static/7821b50bc9463f9ed06a0b77e129dda6/nav-logo-dark-cn.svg',
      mob_en: 'https://res.insta360.com/static/f0057eb9016d0563e4f561572e962b6b/nav-logo-dark-en.svg',
    },
    colorType: 0,
    actColorType: 0,
    searchIcon: 'https://res.insta360.com/static/e7785c23fcbc4c6374ab1575d5647b08/dark-search-icon.svg',
  },
};

export const getSubMenuServiceConfig = (isProd, code) => {
  const config = {};

  config[isProd ? (code === 'CN' ? 102 : 105) : code === 'CN' ? 180 : 177] = {
    type: 'care',
    categoryPageId: isProd ? 78 : 78,
    icon: 'https://res.insta360.com/static/2700f5d9e089ec0a5b61303d4fa180a2/%E7%BC%96%E7%BB%84%207.png',
    text: 'common.nav.subNav_care_title',
  };
  config[isProd ? (code === 'CN' ? 101 : 106) : code === 'CN' ? 181 : 176] = {
    type: 'flexicare',
    categoryPageId: isProd ? 77 : 77,
    icon: 'https://res.insta360.com/static/f6791511a0d3a53b5ae1ea8b719900ff/Insta360%20FlexiCare.png',
    text: 'common.nav.subNav_flexicare_title',
  };
  config[isProd ? (code === 'CN' ? 103 : 104) : code === 'CN' ? 182 : 179] = {
    type: 'insurance',
    categoryPageId: isProd ? 79 : 79,
    icon: 'https://res.insta360.com/static/f858b2aa078f8128a91766b26966908b/Frame%201973770803.png',
    text: 'common.nav.subNav_insurance_title',
  };

  if (code === 'CN') {
    config[isProd ? 107 : 185] = {
      type: '8k',
      categoryPageId: isProd ? 81 : 82,
      icon: 'https://res.insta360.com/static/7d295786c5eeaf08c233a624f1649f14/20240428-141331.png',
      text: 'common.nav.subNav_service_title',
    };
  }

  return config;
};

// 统一使用规格：780 x 780
export const customMasterConfig = {
  24: {
    url: 'https://res.insta360.com/static/d65f7ff321502023f2cd1286414994ec/GO%203-1.png',
  },
  25: {
    url: 'https://res.insta360.com/static/6f24e3786607c9751b6b57831aa2c878/ace-1-2.png',
  },
  27: {
    url: 'https://res.insta360.com/static/a14322ec64d98a2139393c521a6c9164/GO%203S-1.png',
  },
  28: {
    url: 'https://res.insta360.com/static/85354552a397895d3a8e453ef0605ac7/Flow%20Pro.png',
  },
  29: {
    url: 'https://res.insta360.com/static/9d6bc4fa4067fe6ed1dcd239408fd2db/Link2&2C.png',
  },
  30: {
    url: 'https://res.insta360.com/static/04c0127af07b2994dbaaf057b812ee53/AcePro2.png',
  },
  32: {
    url: 'https://res.insta360.com/static/f51fcc468c3894d0cae4260c28db7c7c/Flow%202%20Pro%2001.png',
  },
};

/**
 * @description 通过cid配置导航自定义主图（优先匹配cid，其次匹配上方的pid
 */
export const customCidMasterConfig = {
  3683: {
    url: 'https://res.insta360.com/static/8ccfc410788a24711b3834bc9b8682ff/doraemon_banner.png',
  },
  // X4-BMW联名款
  3647: {
    url: 'https://res.insta360.com/static/e9e18fce6cf6ccb0907a1d045b6d9b57/X4BMW.png',
  },
  // X4-PM联名款
  3691: {
    url: 'https://res.insta360.com/static/c2c26998341be2253e004979d54bf68b/X4Peter.png',
  },
};

/**
 * @description 获取一级导航额外的配置信息
 */
export const getExtraNavInfo = ({ isProd = false }) => {
  return {
    [isProd ? 125 : 127]: {
      icon: (
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.2381 3.82764C11.7628 3.82764 13.8095 5.79407 13.8095 8.21979C16.1239 8.21979 18 10.0224 18 12.2459C18 14.4695 16.1239 16.2721 13.8095 16.2721H6.19048C3.87614 16.2721 2 14.4695 2 12.2459C2 10.5357 3.10982 9.07459 4.67524 8.49105C4.66955 8.40133 4.66667 8.31089 4.66667 8.21979C4.66667 5.79407 6.71337 3.82764 9.2381 3.82764Z'
            strokeWidth='1.6'
          />
          <path
            d='M9.11133 12.219C9.11133 10.0099 10.9022 8.21899 13.1113 8.21899'
            strokeWidth='1.6'
            strokeLinecap='round'
          />
        </svg>
      ),
    },
  };
};
